module.exports = __webpack_public_path__ + "img/tonga.18ee9ea.webp";